import OadpUpload from './oadp-upload';
export default OadpUpload;
